import { Injectable, inject } from '@angular/core';
import { HdContentLanguageService } from '../hd-content-language.service';

const HD_NODAL_ENVIRONMENTS_ASSET_BASE = '/assets/docs/human-design/nodal-environments';
const HD_NODAL_ENVIRONMENT_MARKDOWN_LANGUAGES = new Set(['nl', 'en']);

/**
 * URL-builder voor de markdown-documenten van het nodale-omgevingen-paneel:
 * één `general`-document plus één document per omgeving-paar (`"4-49"`), per
 * contenttaal onder `docs/human-design/nodal-environments/{nl,en}/`. Spiegelt
 * {@link HdRelationInfoService}.
 */
@Injectable({ providedIn: 'root' })
export class HdNodalEnvironmentsInfoService {
  private readonly contentLanguage = inject(HdContentLanguageService);

  /** `file` is `'general'` of een omgeving-sleutel zoals `'4-49'`. */
  markdownUrl(file: string, lang?: string): string {
    return `${HD_NODAL_ENVIRONMENTS_ASSET_BASE}/${this.resolveMarkdownLanguage(lang)}/${file}.md`;
  }

  private resolveMarkdownLanguage(lang?: string): string {
    const requestedLanguage = lang ?? this.contentLanguage.effectiveLang();
    const normalizedLanguage = (requestedLanguage || '').toLowerCase().split('-')[0];
    return HD_NODAL_ENVIRONMENT_MARKDOWN_LANGUAGES.has(normalizedLanguage) ? normalizedLanguage : 'nl';
  }
}
